import _classCallCheck from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import { PermissionModule } from '@/store/modules/permission';
import { SettingsModule } from '@/store/modules/settings';
import SidebarItem from './SidebarItem.vue';
import SidebarLogo from './SidebarLogo.vue';
import variables from '@/styles/_variables.scss';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    _classCallCheck(this, default_1);
    return _callSuper(this, default_1, arguments);
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "sidebar",
    get: function get() {
      return AppModule.sidebar;
    }
  }, {
    key: "routes",
    get: function get() {
      return PermissionModule.routes;
    }
  }, {
    key: "showLogo",
    get: function get() {
      return SettingsModule.showSidebarLogo;
    }
  }, {
    key: "menuActiveTextColor",
    get: function get() {
      if (SettingsModule.sidebarTextTheme) {
        return SettingsModule.theme;
      } else {
        return variables.menuActiveText;
      }
    }
  }, {
    key: "variables",
    get: function get() {
      return variables;
    }
  }, {
    key: "activeMenu",
    get: function get() {
      var route = this.$route;
      var meta = route.meta,
        path = route.path;
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    }
  }, {
    key: "isCollapse",
    get: function get() {
      return !this.sidebar.opened;
    }
  }]);
}(Vue);
default_1 = __decorate([Component({
  name: 'SideBar',
  components: {
    SidebarItem: SidebarItem,
    SidebarLogo: SidebarLogo
  }
})], default_1);
export default default_1;